import { Flex, Modal } from "antd";
import styled from "styled-components";

import { SecondaryText } from "@/shared/ui/Typography";

export const StyledISIModal = styled(Modal)`
    .ant-modal-content {
        padding: 0 !important;
    }
`;

export const StyledISIBlock = styled(Flex)`
    width: 100%;
    margin-top: 16px;
    padding: 12px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border-left: 1px solid ${({ theme }) => theme.colors.warning};
    background-color: ${({ theme }) =>
        theme.collapseHeaderBackground} !important;

    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const StyledISISum = styled(SecondaryText)`
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.itemBorder} !important;
    text-align: left;
`;
